import { createFileRoute } from '@tanstack/react-router'

import { DashboardResolver } from '@/widgets/dashboard-resolver'

export const Route = createFileRoute('/_dashboard/branch/$branchId/booking/')({
    component: DashboardResolver,
})
